import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { RouterModule } from '@angular/router';
import { UtilService } from '../../services/util.service';
import { LoginService } from '../../services/login.service';

@Component({
  selector: 'app-login',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.scss'],
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    RouterModule,
    CommonModule
  ],
})
export class SignInComponent {
  loginForm!: FormGroup;
  isRegInProgress = false;

  constructor(private fb: FormBuilder, private utilService: UtilService, private authService: LoginService) { }

  ngOnInit(): void {
    this.loginForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
    });
  }

  onSubmit(): void {
    if (this.loginForm.valid) {
      // Handle successful login
      console.log('Form Submitted', this.loginForm.value);
      this.isRegInProgress = true;
      this.authService.sendMagicLink(this.loginForm.value.email).subscribe({
        next: (res: any) =>  {
          this.utilService.openSnackBar('A mail was sent to your email address. Follow the instructions in the mail to log-in.', 'Close', 'success');
          this.isRegInProgress = false;
        },
        error: (err: any) => {
          this.isRegInProgress = false;
          if (err?.error?.errorDetail === 'User does not exist.') {
            // Even for a non-existent user, we show the same message as for a successful login
            this.utilService.openSnackBar('A mail was sent to your email address. Follow the instructions in the mail to log-in.', 'Close', 'success');  
          } else if (err?.error?.error) {
            this.utilService.openSnackBar(err.error.error, 'Close', 'error')
          } else {
            this.utilService.openSnackBar('An error occurred. Please try again later.', 'Close', 'error')
          }
        }
      });
    }
  }

}
